import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getSessionId } from './session';

// Подключение к /ws с sessionId (передаётся в query — сервер не отправит обратно
// этому клиенту его собственные invalidations). Фокусированный refetch только
// тех queries, чей путь упомянут в broadcast (path → match по queryKey префиксу).
export function useRealtime() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const sessionId = getSessionId();
    const url = `${proto}://${window.location.host}/ws?session=${encodeURIComponent(sessionId)}`;

    let ws: WebSocket | null = null;
    let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
    let closed = false;
    let backoffMs = 1000;

    const connect = () => {
      ws = new WebSocket(url);
      ws.onopen = () => {
        backoffMs = 1000; // reset на успешном подключении
      };
      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'invalidate' && typeof data.path === 'string') {
            const root = data.path.split('.')[0];
            queryClient.invalidateQueries({ queryKey: [[root]] });
            queryClient.invalidateQueries({ queryKey: [root] });
          }
        } catch {
          /* ignore parse errors */
        }
      };
      ws.onclose = () => {
        if (!closed) {
          reconnectTimer = setTimeout(connect, backoffMs);
          backoffMs = Math.min(backoffMs * 2, 30000); // exponential backoff до 30s (#M8)
        }
      };
      ws.onerror = () => {
        ws?.close();
      };
    };

    connect();

    return () => {
      closed = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      ws?.close();
    };
  }, [queryClient]);
}
